import React, { useEffect } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { Loading } from "../components/Loading";
import PricingCard from "../components/subscription/PricingCard";

import { fetchStatus } from "../store/slices/preferenceSlice";

// cms
import { useCmsHook } from "../helpers/cmsHook";
import { CmsConstructor } from "../helpers/CmsConstructor";
import CmsEditAndSave from "../helpers/CmsEditAndSave";

function Subscription() {
  const { setCmsInstance, cmsInstance } = useCmsHook();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const {
    subscription: { planData },
  } = useSelector((state) => state.subscription);

  useEffect(() => {
    const portalId = searchParams.get("portalId");
    dispatch(fetchStatus(portalId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/subscription") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {window.location.pathname === "/subscription" && (
        <div className="d-flex flex-column align-items-center my-3">
          <CmsEditAndSave />
        </div>
      )}
      <Container className="mt-4 mb-5">
        <Row className="d-flex flex-row justify-content-center">
          <Col xs={12} className="px-0">
            <div className="subscription-container">
              {cmsInstance &&
                cmsInstance.showRichText("cmsContent.subscriptionPage.text")}

              <Alert variant="warning" style={{ fontSize: "12px" }}>
                If the popup does not appear after clicking the upgrade button,
                please enable popups in your browser and proceed with the
                subscription process.
              </Alert>
            </div>

            <div>
              {Object.keys(planData).length <= 0 || !cmsInstance ? (
                <Loading />
              ) : (
                <PricingCard />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Subscription;
